import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const getAuthParam = () => {
  const token = localStorage.getItem('c3i_token');
  return token ? `Bearer ${token}` : '';
};

// Stats
export const fetchDashboardStats = async () => {
  const response = await axios.get(`${API}/stats/dashboard?Authorization=${encodeURIComponent(getAuthParam())}`);
  return response.data;
};

export const fetchStatsPerRegione = async () => {
  const response = await axios.get(`${API}/stats/regioni?Authorization=${encodeURIComponent(getAuthParam())}`);
  return response.data;
};

// Ordini
export const fetchOrdini = async (params = {}) => {
  const { search, provincia, regione, page = 1, limit = 20 } = params;
  const queryParams = new URLSearchParams();
  queryParams.append('Authorization', getAuthParam());
  queryParams.append('page', page);
  queryParams.append('limit', limit);
  if (search) queryParams.append('search', search);
  if (provincia && provincia !== 'all') queryParams.append('provincia', provincia);
  if (regione && regione !== 'all') queryParams.append('regione', regione);
  
  const response = await axios.get(`${API}/ordini?${queryParams.toString()}`);
  return response.data;
};

export const fetchRegioni = async () => {
  const response = await axios.get(`${API}/ordini/regioni?Authorization=${encodeURIComponent(getAuthParam())}`);
  return response.data;
};

export const fetchOrdine = async (id) => {
  const response = await axios.get(`${API}/ordini/${id}?Authorization=${encodeURIComponent(getAuthParam())}`);
  return response.data;
};

export const updateOrdine = async (id, data) => {
  const response = await axios.put(`${API}/ordini/${id}?Authorization=${encodeURIComponent(getAuthParam())}`, data);
  return response.data;
};

// Persone
export const fetchPersone = async (params = {}) => {
  const { search, ordine_id, page = 1, limit = 50 } = params;
  const queryParams = new URLSearchParams();
  queryParams.append('Authorization', getAuthParam());
  queryParams.append('page', page);
  queryParams.append('limit', limit);
  if (search) queryParams.append('search', search);
  if (ordine_id) queryParams.append('ordine_id', ordine_id);
  
  const response = await axios.get(`${API}/persone?${queryParams.toString()}`);
  return response.data;
};

export const fetchPersona = async (id) => {
  const response = await axios.get(`${API}/persone/${id}?Authorization=${encodeURIComponent(getAuthParam())}`);
  return response.data;
};

export const createPersona = async (data) => {
  const response = await axios.post(`${API}/persone?Authorization=${encodeURIComponent(getAuthParam())}`, data);
  return response.data;
};

export const updatePersona = async (id, data) => {
  const response = await axios.put(`${API}/persone/${id}?Authorization=${encodeURIComponent(getAuthParam())}`, data);
  return response.data;
};

export const deletePersona = async (id) => {
  const response = await axios.delete(`${API}/persone/${id}?Authorization=${encodeURIComponent(getAuthParam())}`);
  return response.data;
};

// Deleghe
export const fetchDeleghe = async (params = {}) => {
  const { ordine_id, stato, page = 1, limit = 20 } = params;
  const queryParams = new URLSearchParams();
  queryParams.append('Authorization', getAuthParam());
  queryParams.append('page', page);
  queryParams.append('limit', limit);
  if (ordine_id) queryParams.append('ordine_id', ordine_id);
  if (stato) queryParams.append('stato', stato);
  
  const response = await axios.get(`${API}/deleghe?${queryParams.toString()}`);
  return response.data;
};

export const fetchDelega = async (id) => {
  const response = await axios.get(`${API}/deleghe/${id}?Authorization=${encodeURIComponent(getAuthParam())}`);
  return response.data;
};

export const fetchDelegaByOrdine = async (ordineId) => {
  const response = await axios.get(`${API}/deleghe/ordine/${ordineId}?Authorization=${encodeURIComponent(getAuthParam())}`);
  return response.data;
};

export const updateDelega = async (id, data) => {
  const response = await axios.put(`${API}/deleghe/${id}?Authorization=${encodeURIComponent(getAuthParam())}`, data);
  return response.data;
};

// GTL
export const fetchGTL = async (params = {}) => {
  const { search, stato, page = 1, limit = 20 } = params;
  const queryParams = new URLSearchParams();
  queryParams.append('Authorization', getAuthParam());
  queryParams.append('page', page);
  queryParams.append('limit', limit);
  if (search) queryParams.append('search', search);
  if (stato) queryParams.append('stato', stato);
  
  const response = await axios.get(`${API}/gtl?${queryParams.toString()}`);
  return response.data;
};

export const fetchGTLDetail = async (id) => {
  const response = await axios.get(`${API}/gtl/${id}?Authorization=${encodeURIComponent(getAuthParam())}`);
  return response.data;
};

export const createGTL = async (data) => {
  const response = await axios.post(`${API}/gtl?Authorization=${encodeURIComponent(getAuthParam())}`, data);
  return response.data;
};

export const updateGTL = async (id, data) => {
  const response = await axios.put(`${API}/gtl/${id}?Authorization=${encodeURIComponent(getAuthParam())}`, data);
  return response.data;
};

export const deleteGTL = async (id) => {
  const response = await axios.delete(`${API}/gtl/${id}?Authorization=${encodeURIComponent(getAuthParam())}`);
  return response.data;
};

// GTL Members
export const addGTLMember = async (gtlId, data) => {
  const response = await axios.post(`${API}/gtl/${gtlId}/membri?Authorization=${encodeURIComponent(getAuthParam())}`, data);
  return response.data;
};

export const updateGTLMember = async (membershipId, data) => {
  const response = await axios.put(`${API}/gtl/membri/${membershipId}?Authorization=${encodeURIComponent(getAuthParam())}`, data);
  return response.data;
};

export const removeGTLMember = async (membershipId) => {
  const response = await axios.delete(`${API}/gtl/membri/${membershipId}?Authorization=${encodeURIComponent(getAuthParam())}`);
  return response.data;
};

// GTL Member Proposals
export const fetchPendingProposals = async () => {
  const response = await axios.get(`${API}/gtl/proposte/pending?Authorization=${encodeURIComponent(getAuthParam())}`);
  return response.data;
};

export const handleProposal = async (propostaId, azione, motivo = null) => {
  const queryParams = new URLSearchParams();
  queryParams.append('Authorization', getAuthParam());
  queryParams.append('azione', azione);
  if (motivo) queryParams.append('motivo', motivo);
  const response = await axios.put(`${API}/gtl/proposte/${propostaId}?${queryParams.toString()}`);
  return response.data;
};

// Export
export const exportDelegati = () => {
  window.open(`${API}/export/delegati?Authorization=${encodeURIComponent(getAuthParam())}`, '_blank');
};

export const exportSupplenti = () => {
  window.open(`${API}/export/supplenti?Authorization=${encodeURIComponent(getAuthParam())}`, '_blank');
};

export const exportGTLMembers = (gtlId) => {
  window.open(`${API}/export/gtl/${gtlId}?Authorization=${encodeURIComponent(getAuthParam())}`, '_blank');
};

export const exportUsersCSV = () => {
  window.open(`${API}/users/export-csv?Authorization=${encodeURIComponent(getAuthParam())}`, '_blank');
};

// Bulk Import
export const validateBulkUsers = async (users) => {
  const response = await axios.post(
    `${API}/users/bulk-validate?Authorization=${encodeURIComponent(getAuthParam())}`,
    { users, dry_run: true }
  );
  return response.data;
};

export const importBulkUsers = async (users) => {
  const response = await axios.post(
    `${API}/users/bulk-import?Authorization=${encodeURIComponent(getAuthParam())}`,
    { users, dry_run: false }
  );
  return response.data;
};

// Audit
export const fetchAuditLogs = async (params = {}) => {
  const { page = 1, limit = 50 } = params;
  const queryParams = new URLSearchParams();
  queryParams.append('Authorization', getAuthParam());
  queryParams.append('page', page);
  queryParams.append('limit', limit);
  
  const response = await axios.get(`${API}/audit?${queryParams.toString()}`);
  return response.data;
};

// Users
export const fetchUsers = async () => {
  const response = await axios.get(`${API}/users?Authorization=${encodeURIComponent(getAuthParam())}`);
  return response.data;
};

export const createUser = async (data) => {
  const response = await axios.post(`${API}/auth/register?Authorization=${encodeURIComponent(getAuthParam())}`, data);
  return response.data;
};

export const updateUser = async (userId, userData) => {
  const response = await axios.put(`${API}/users/${userId}?Authorization=${encodeURIComponent(getAuthParam())}`, userData);
  return response.data;
};

export const deleteUser = async (userId) => {
  const response = await axios.delete(`${API}/users/${userId}?Authorization=${encodeURIComponent(getAuthParam())}`);
  return response.data;
};

// Seed
export const seedDatabase = async () => {
  const response = await axios.post(`${API}/seed`);
  return response.data;
};
